import * as angular from 'angular';

import { IApprovalStrategy } from '../../models';
import { IDispatcherService, IDispatcher, IApprovalStrategyActionsService } from '..';

export interface IApprovalStrategyStoreService {
    create(strategy:IApprovalStrategy): angular.IPromise<IApprovalStrategy[]>;
    update(strategy:IApprovalStrategy): angular.IPromise<IApprovalStrategy[]>;
    delete(guid:string): angular.IPromise<IApprovalStrategy[]>;
    getOne(guid:string): angular.IPromise<IApprovalStrategy>;
    getAll(): angular.IPromise<IApprovalStrategy[]>;
    getAll(force:boolean): angular.IPromise<IApprovalStrategy[]>;
}

export interface IApprovalStrategyActionsDispatcherService extends IDispatcherService<IApprovalStrategyStoreService> { }

export class ApprovalStrategyActionsDispatcherService implements IApprovalStrategyActionsDispatcherService {
    static serviceId = 'approvalStrategyActionsDispatcherService';

    static $inject = ['approvalStrategyActionsService'];

    constructor(private _actionService: IApprovalStrategyActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IApprovalStrategyStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                create: (strategy: IApprovalStrategy) => dispatch(actionService.addOne(strategy)),
                update: (strategy: IApprovalStrategy) => dispatch(actionService.updateOne(strategy)),
                delete: (guid:string) => dispatch(actionService.deleteOne(guid)),
            }
        };
    }
}